import { useEffect, useState } from "react";

import { ControlGroup, MenuItem } from "@blueprintjs/core";

import { authenticatedGetFetch } from "../../utils/AuthenticatedFetch";
import { MultiSelect } from "@blueprintjs/select";

export function MultiContactSelect(props) {
  const [contactList, setContactList] = useState([]);
  const [contacts, _setContacts] = useState(props.initSelection ? props.initSelection.map(c=>c.index): []);

  function setContacts(contacts) {
    _setContacts(contacts);
    console.log(contacts);
    if (props.onSelect !== undefined) props.onSelect(contacts);
  }

  useEffect(() => {
    authenticatedGetFetch("/phonie/contacts", (response) =>
      setContactList(response)
    );
  }, []);

  return (
    <ControlGroup fill={true}>
      <MultiSelect
        items={contactList}
        selectedItems={contacts}
        itemRenderer={(val, itemProps) => {
          if (contacts.includes(val.index))
            return null; // hide already selected contacts
          else
            return (
              <MenuItem
                key={val.index}
                text={val?.name}
                label={val.number}
                onClick={(elm) => {
                  if (contacts.includes(val.index)) {
                    setContacts(contacts.filter((filtre) => filtre !== val.index));
                  } else {
                    setContacts([...contacts, val.index]);
                  }
                }}
                selected={contacts.includes(val.index)}
              />
            );
        }}
        itemListPredicate={(query, items) => {
          return items.filter((filtre) =>
            filtre?.name?.toLowerCase().includes(query?.toLowerCase())
          );
        }}
        onItemSelect={() => {}}
        tagRenderer={(index) =>
          contactList.filter((contact) => contact.index === index)[0]?.name
        }
        onRemove={(item) => {
          setContacts(contacts.filter((elm) => elm !== item));
        }}
        onClear={() => setContacts([])}
      />
    </ControlGroup>
  );
}
